<template>
    <div>
        <v-container>
            <v-row>
                <v-col class="text-center">
                    <v-alert type="error">{{ message }}</v-alert>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import GuestLayout from "../../../Layouts/GuestLayout";

export default {
    name: "ApproveDenyError",
    layout: [GuestLayout],
    props: {
        message: {
            type: String,
            default: 'An error has occurred.'
        }
    }
}
</script>

<style scoped>

</style>
